<template>
  <div id="chooseAddress">
    <div v-if="type == 'search'">
      <div class="province">
        <address-item
          v-if="roleId < 3"
          :title="proTitle"
          :value="province"
          :list="provinceList"
          :handlerSelect="selectProvince"
        />
      </div>
      <div class="city">
        <address-item
          v-if="roleId < 4"
          :title="cityTitle"
          :value="city"
          :list="cityList"
          :handlerSelect="selectCity"
        ></address-item>
      </div>
      <div class="district">
        <address-item
          v-if="roleId < 5"
          :title="disTitle"
          :value="district"
          :list="districtList"
          :handlerSelect="selectDistrict"
        ></address-item>
      </div>
    </div>
    <div v-else>
      <div class="province">
        <address-item
          :title="proTitle"
          :value="province"
          :list="provinceList"
          :handlerSelect="selectProvince"
          :isClick="pIsClick"
        />
      </div>
      <div class="city">
        <address-item
          :title="cityTitle"
          :value="city"
          :list="cityList"
          :handlerSelect="selectCity"
          :isClick="cIsClick"
        ></address-item>
      </div>
      <div class="district">
        <address-item
          :title="disTitle"
          :value="district"
          :list="districtList"
          v-model:list="districtList"
          :handlerSelect="selectDistrict"
          :isClick="dIsClick"
        ></address-item>
      </div>
    </div>
  </div>
</template>

<script>
// areaData,
import {  getLocal } from "@/common/js";
import {getAreaList} from "@/service/area";
import { reactive, toRefs, onMounted, watch } from "vue";
import AddressItem from "./AddressItem";
export default {
  name: "CompAddress",
  props: {
    province: {
      type: String,
      default: "不限",
    },
    provinceCode: {
      type: String,
      default: "",
    },
    district: {
      type: String,
      default: "不限",
    },
    districtCode: {
      type: String,
      default: "",
    },
    city: {
      type: String,
      default: "不限",
    },
    cityCode: {
      type: String,
      default: "",
    },
    selectArea: {
      type: Function,
    },
    type: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const state = reactive({
      areaData: {},
      proTitle: "省",
      province: props.province,
      provinceCode: props.provinceCode || "100000",

      cityTitle: "市",
      city: props.city,
      cityCode: props.cityCode,
      disTitle: "区",
      district: props.district,
      districtCode: props.districtCode,

      provinceList: {},
      cityList: {},
      districtList: {},

      roleId: -1,
      pIsClick: true,
      cIsClick: true,
      dIsClick: true,
    });
    onMounted(async () => {
      // 根据角色回显省市区
      const role = await getLocal("dsj_roleId");
      if (role) {
        state.roleId = role;
        const intRoleId = parseInt(role);
        if (intRoleId >= 5) {
          state.pIsClick = false;
          state.cIsClick = false;
          state.dIsClick = false;
        } else if (intRoleId >= 4) {
          state.pIsClick = false;
          state.cIsClick = false;
        } else if (intRoleId >= 3) {
          state.pIsClick = false;
        }
      }
      getAreaData()
    });
    const getAreaData = async () => {
        const {data, code} = await getAreaList();
        if(code === 10000) {
          state.areaData = data;
          init();
        }
    }
    const init = async () => {
      const { provinceCode } = props;
      let pcode = provinceCode;
      if (!pcode) {
        pcode = 100000;
      }
      getProvince(pcode);
      if (props.province != "不限" && props.province != "") {
        const pcode = props.provinceCode;
        searchCity(pcode.substring(0, 4));
      }
      if (props.city != "" && props.city != "不限") {
        const ccode = props.cityCode;
        searchDistrict(ccode);
      }
    };
    watch(props, (newProps) => {
      const { province, provinceCode, city, cityCode, district, districtCode } = newProps;
      state.province = province;
      state.provinceCode = provinceCode;
      state.city = city;
      state.cityCode = cityCode;
      state.distric = district;
      state.district = districtCode;
      if (props.province != "不限" && props.province != "") {
        const pcode = props.provinceCode;
        searchCity(pcode.substring(0, 4));
      }
      if (props.city != "" && props.city != "不限") {
        const ccode = props.cityCode;
        searchDistrict(ccode);
      }
    });

    const getProvince = (code) => {
      if (!code) {
        return false;
      }
      const list = state.areaData[code];
      state.provinceList = Object.assign({ 0: "不限", ...list });
    };
    const selectProvince = (name, key) => {
      // console.log('name, key --> ', name, key)
      state.province = name;
      state.provinceCode = key;
      props.selectArea({ province: name, provinceCode: key, city: "不限", cityCode: 0, district: "不限", districtCode: 0 });
      searchCity(key);
    };
    const searchCity = (code) => {
      if (!code) {
        return;
      }
      const list = state.areaData[code];
      state.cityList = Object.assign({ 0: "不限", ...list });
    };

    const selectCity = (name, key) => {
      state.city = name;
      state.cityCode = key;
      props.selectArea({ city: name, cityCode: key, district: "不限", districtCode: 0 });
      searchDistrict(key);
    };
    const searchDistrict = (code) => {
      if (!code) {
        return;
      }
      const list = state.areaData[code];
      state.districtList = Object.assign({ 0: "不限", ...list });
    };

    const selectDistrict = (name, key) => {
      state.district = name;
      state.districtCode = key;
      props.selectArea({ district: name, districtCode: key });
    };
    return {
      ...toRefs(state),
      close,
      getProvince,
      selectProvince,
      selectDistrict,
      selectCity,
    };
  },
  components: {
    AddressItem,
  },
};
</script>

<style lang="less" scoped>
.select_box {
  margin-right: 15px;
}
</style>
